import React from 'react';

import { Link } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui/box';
import { getDesignToken, layout, spacing } from 'styles/constants';

export const CardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.cardContainer, style],
  });

export const Price = withTypography({
  color: getDesignToken('text-disabled'),
  fontSize: 'sm',
  lineHeight: 'sm',
});

export const ItemName = withTypography({ fontFamily: 'heading', fontSize: 'md', mt: '$1' });

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: getDesignToken('color-tertiary'),
      },
    },
  },
});

const styles = StyleSheet.create({
  cardContainer: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-pattern'),
    borderRadius: 8,
    flexDirection: 'row',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$3,
    width: layout.full,
  },
});
